import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Switch from '../../../../../shared/components/switch';
import { NotesSwitchData } from '../utils/types';
import MyNotesSharePromptModal from './MyNotesSharePromptModal';

const SwitchGroup = styled.div`
  & > div:not(:last-of-type) {
    margin-bottom: 16px;
  }
  margin-bottom: 0px;
`;
interface Props{
  notesSwitchData: NotesSwitchData,
  setNotesSwitchData: React.Dispatch<React.SetStateAction<NotesSwitchData>>
  showAgendaToggle?: boolean
  showSharedNotesToggle?: boolean
  showTaskToggle?: boolean
  showMyNotesToggle?: boolean
}

export default function NotesSwitch({
  notesSwitchData, setNotesSwitchData,
  showAgendaToggle,
  showSharedNotesToggle,
  showMyNotesToggle,
  showTaskToggle,
}:Props) {
  const {
    isAgendaNotesChecked, isAgendaNotesDisabled, isAgendaNotesEnabled,
    isSharedNotesChecked, isSharedNotesDisabled, isPersonalNotesChecked,
    isPersonalNotesDisabled, isTasksChecked, isTasksDisabled,
  } = notesSwitchData;

  const [isMyNotesSharePromptOpen, setIsMyNotesSharePromptOpen] = useState(false);

  const setAgendaNotesChecked = (value: boolean) => {
    console.log('setAgendaNotesChecked', value, notesSwitchData);
    const notesData:NotesSwitchData = {
      ...notesSwitchData,
      isAgendaNotesChecked: value,
    };
    setNotesSwitchData(notesData);
  };

  const setSharedNotesChecked = (value: boolean) => {
    console.log('setSharedNotesChecked', value, notesSwitchData);
    const notesData:NotesSwitchData = {
      ...notesSwitchData,
      isSharedNotesChecked: value,
    };
    setNotesSwitchData(notesData);
  };

  const setPersonalNotesChecked = (value: boolean) => {
    setIsMyNotesSharePromptOpen(value);
    console.log('setPersonalNotesChecked', value, notesSwitchData);
    const notesData:NotesSwitchData = {
      ...notesSwitchData,
      isPersonalNotesChecked: value,
    };
    setNotesSwitchData(notesData);
  };

  const setTasksChecked = (value: boolean) => {
    console.log('setTasksChecked', value, notesSwitchData);
    const notesData:NotesSwitchData = {
      ...notesSwitchData,
      isTasksChecked: value,
    };
    setNotesSwitchData(notesData);
  };

  useEffect(() => {
    console.log('isSwitch', isSharedNotesDisabled);
  }, [isSharedNotesDisabled]);

  return (
    <>
      <SwitchGroup>
        {showAgendaToggle && isAgendaNotesEnabled && (
        <Switch
          label="Agenda"
          checked={isAgendaNotesChecked}
          setChecked={setAgendaNotesChecked as React.Dispatch<React.SetStateAction<boolean>>}
          disabled={isAgendaNotesDisabled}
          disabledTooltipText="No agenda"
        />
        )}
        {showSharedNotesToggle && (
          <Switch
            label="Shared notes"
            checked={isSharedNotesChecked}
            setChecked={setSharedNotesChecked as React.Dispatch<React.SetStateAction<boolean>>}
            disabled={isSharedNotesDisabled}
            disabledTooltipText="No shared notes"
          />
        )}
        { showMyNotesToggle && (
        <Switch
          label="My notes"
          checked={isPersonalNotesChecked}
          setChecked={setPersonalNotesChecked as React.Dispatch<React.SetStateAction<boolean>>}
          disabled={isPersonalNotesDisabled}
          disabledTooltipText="No personal notes"
        />
        )}
        {showTaskToggle && (
        <Switch
          label="Tasks"
          checked={isTasksChecked}
          setChecked={setTasksChecked as React.Dispatch<React.SetStateAction<boolean>>}
          disabled={isTasksDisabled}
          disabledTooltipText="No tasks"
        />
        )}
      </SwitchGroup>
      <MyNotesSharePromptModal
        isOpen={isMyNotesSharePromptOpen}
        handleCloseClick={() => { setIsMyNotesSharePromptOpen(false); }}
        notesSwitchData={notesSwitchData}
        setNotesSwitchData={setNotesSwitchData}
      />
    </>
  );
}

NotesSwitch.defaultProps = {
  showAgendaToggle: true,
  showSharedNotesToggle: true,
  showMyNotesToggle: true,
  showTaskToggle: true,
};
